/**
 * Date utility functions - matching the original website functionality
 */

/**
 * Get current time string in Vietnamese format (DD/MM/YYYY HH:mm:ss)
 */
export const getCurrentTimeString = () => {
  const now = new Date();
  const day = now.getDate().toString().padStart(2, '0');
  const month = (now.getMonth() + 1).toString().padStart(2, '0');
  const year = now.getFullYear();
  const hours = now.getHours().toString().padStart(2, '0');
  const minutes = now.getMinutes().toString().padStart(2, '0');
  const seconds = now.getSeconds().toString().padStart(2, '0');
  
  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
};

/**
 * Get URL parameters (for search form history)
 */
export const getUrlParams = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return {
    day: urlParams.get('gold_history_day') || '',
    month: urlParams.get('gold_history_month') || '',
    year: urlParams.get('gold_history_year') || ''
  };
};

/**
 * Generate date options for select dropdowns
 */
export const getDateOptions = () => {
  const days = [];
  for (let i = 1; i <= 31; i++) {
    const value = i.toString().padStart(2, '0');
    days.push({ value, label: value });
  }
  
  const months = [];
  for (let i = 1; i <= 12; i++) {
    const value = i.toString().padStart(2, '0');
    months.push({ value, label: value });
  }
  
  const years = [2025, 2024, 2023, 2022, 2021, 2020, 2019, 2018, 2017, 2016];
  const yearOptions = years.map(year => ({ value: year.toString(), label: year.toString() }));
  
  return { days, months, years: yearOptions };
}; 